import api from './api';

export const vendorService = {
  getAllVendors: async (filter = 'all') => {
    const response = await api.get('/vendors', { params: { filter } });
    return response.data;
  },

  getVendor: async (id) => {
    const response = await api.get(`/vendors/${id}`);
    return response.data;
  },

  createVendor: async (vendorData) => {
    const response = await api.post('/vendors', vendorData);
    return response.data;
  },

  updateVendor: async (id, vendorData) => {
    const response = await api.put(`/vendors/${id}`, vendorData);
    return response.data;
  },

  deleteVendor: async (id) => {
    const response = await api.delete(`/vendors/${id}`);
    return response.data;
  },

  getVendorSales: async (type) => {
    const response = await api.get(`/vendors/sales/${type}`);
    return response.data;
  },

  // Admin reset vendor password (resets the linked user account)
  resetPassword: async (id, newPassword) => {
    const response = await api.put(`/vendors/${id}/reset-password`, { newPassword });
    return response.data;
  }
};
export default vendorService;